export { default } from "./CarouselTabs";
export * from "./CarouselTabs";
